<template>
  <div class="outerDiv">
    <!-- <header>
      <img alt="logo" :src="logoPath()"  class="logo">
    </header> -->
    <div class='currentScreenDiv'>
      <img alt="logo" :src="logoPath()"  class="logo">
      <!-- ScanBadge -->
      <div v-if='isCurrentScreen("scanBadge")' class="verticalFlex">
        <h2 class="screenTitle">{{scanPrompt}}</h2>
        <h2 class="screenTitle">{{monitorScanResultMessage}}</h2>

        <!-- Use badge value to get image -->
        <!-- <div class="personPhoto" v-if="lastImage!='' && isEmployee">
            <img :src="getImage(badgeValue)"  width="300" class="image" >
        </div> -->
        <div class="personPhoto" v-if="scannedPerson.badge!=null && isEmployee">
            <img :src="getImage(scannedPerson.badge)"  width="300" class="image" >
        </div>
        <input ref="badgeText" id="badgeText" v-model="badgeValue" class='scanText' @keyup.enter='scanUserBadge' />
        <button v-on:click='scanUserBadge' class='Button bold' v-show="!pleaseWait">{{scanButtonText}}</button>
        <div class="wait" v-show="pleaseWait">
          <label for="">Please Wait...</label>
        </div>
        
        <h4 class="thankMessage">{{thanksMessageForFront}}</h4>
        <h4 class="scanMessage">{{messageOnScan}}</h4>
        <h4 class="scanMessage">{{monitorTitle}}</h4>

        
      </div>  

      <!-- Ask if monitor mode -->
      <div v-if='isCurrentScreen("monitorOrAttendee")' class="verticalFlex">
        <h2 class="screenTitle">{{monitorPrompt}}</h2>
        <button v-on:click='modeMonitor' class='Button'>{{monitorButtonText}}</button>
        <button v-on:click='modeAttendee' class='Button'>{{attendeeButtonText}}</button>
      </div> 

      <!-- CheckInType -->
      <div v-if='isCurrentScreen("checkInType")' class="verticalFlex">
        <h2 class="screenTitle">{{selectPrompt}}</h2>
        <button v-on:click='typeBadge' class='Button'>{{typeScanButtonText}}</button>
        <button v-on:click='typeRoster' class='Button'>{{typeRosterButtonText}}</button>
      </div> 

      <!--Roster-->
      <div v-if='isCurrentScreen("roster")' class="verticalFlex">
        <h2 class="screenTitle">{{rosterPrompt}}</h2>
        <div class="leftFlex scrollDivResults">
          <div class="horizFlex" v-for="member in roster" :key="member.id" >
            <input type="checkbox" :id="member.id" v-model="member.selected">
            <label :for="member.id" class="rosterName">{{member.name}}</label>
          </div>
        </div>
        <button v-on:click='checkInRoster' class='Button'>{{rosterCheckInButtonText}}</button>
      </div> 

       <!-- Password -->
      <div v-if='isCurrentScreen("password")' class="verticalFlex">
        <h2 class="screenTitle">{{passwordPrompt}}</h2>
        <input ref="passwordText" class="scanText"/>
        <button class="Button" v-on:click='loginEmployee'>{{loginButtonText}}</button>
      </div>

       <!-- select club -->
      <div v-if='isCurrentScreen("selectClub")' class="verticalFlex">
        
        <div  v-if="!isEmployee">
          <!-- use badge value to get image -->
         <!--  <div class="personPhoto" v-if="lastImage!=''">
            <img :src="getImage(badgeValue)"  width="300" class="image" >
          </div> -->
           <div class="personPhoto" v-if="scannedPerson.badge!=null">
            <img :src="getImage(scannedPerson.badge)"  width="300" class="image" >
          </div>
          <h2 class="screenTitle">{{scannedPerson.firstName}} {{scannedPerson.lastName}}</h2>
          
          <!-- <p>Are you bringing guests today?</p>
        
          <select name="" id="" class='entrySelect' v-model="guestCount" >
                  <option v-for="count in guestCountList" :key="count.ID" :value="count.ID" >
                      {{count.Name}}
                  </option>
          </select>
          <h2 class="screenTitle">{{selectClubPrompt}}</h2> -->
        </div>
        <div class="horixFlex">
          <button :class='buttonclass(club)' v-for="club in clubs" :key="club.clubId" 
              v-on:click='selectUserClub(club.clubId, club.clubName)' >{{club.clubName}}</button>
        </div>
      </div>
      
       <!-- Thanks -->
      <div v-if='isCurrentScreen("thanks")' class="verticalFlex">
        <div >
          <h2 class="screenTitle">{{thanksMessage1}}</h2>
          <h2 class="screenTitle">{{thanksMessage2}}</h2>
          <h2 class="screenTitle">{{selectedClub.name}}</h2>
        </div>
      
        <button v-on:click='startOver' class='Button'>{{startOverButtonText}}</button>
        <h4 class="scanMessage">{{messageOnScan}}</h4>
      </div>

      <!-- Thanks Rostr -->
      <div v-if='isCurrentScreen("thanksRoster")' class="verticalFlex">
        <div >
          <h2 class="screenTitle">{{thanksMessage1}}</h2>
          <div class="verticalFlex">
            <div class="horizFlex" v-for="member in rosterFiltered()" :key="member.id">
             
                <label class="rosterName" >{{member.name}}</label>
              
              
            </div>
          </div>
          <h2>for</h2>
          <h2>{{selectedClub.name}}</h2>
        </div>
        <button v-on:click='showSelectClub' class='Button'>{{startOverButtonText}}</button>
      </div>

      
    </div>
    
    <!-- link buttons -->
    <div class="linkButtonArea">
        <button v-if="showSwitchClub"  v-on:click='showSelectClub' class='linkButton'>{{switchClubButtonText}}</button>
        <button v-if="showCancel" v-on:click='startOver' class='cancelbutton'>{{cancelButtonText}}</button>
        <button v-if="showLogout" v-on:click='logoutEmployee' class='linkButton'>{{logoutButtonText}}</button>     
    </div>

    <footer>
        <div>
          <p class="footerText">{{footerText}}</p>
          <img alt="footer logo" :src="footerLogoPath()"  class="footerLogo">
        </div>
    </footer>
  </div>
</template>

<script>

//import axios from 'axios';
import {HTTP} from '../Repository'
import axios from "axios";

export default {
  components:{
 
  },
  name: 'HelloWorld',
  props: {
    msg: String
  }, 
  data(){
    return{
      imageBasePath:'',

      pleaseWait:false,

      currentScreen:'',
      isRosterCheckIn:false,
    
      roster:[],
      clubs:[],

      badgeValue:'',
      scannedPerson:{},
      loggedInPerson:{},
      isEmployee:false,
      isLoggedIn:false,

      guestCount:0,
      guestCountList:[
        {ID:0,Name:'0'},
        {ID:1,Name:'1'},
        {ID:2,Name:'2'},
        {ID:3,Name:'3'},
        {ID:4,Name:'4'},
        {ID:5,Name:'5'},
        {ID:6,Name:'6'},
        {ID:7,Name:'7'},
        {ID:8,Name:'8'},
        {ID:9,Name:'9'},
      ],


      selectedClub:{},

      messageOnScan:'',
      monitorTitle:'',
      monitorScanResultMessage:'',
      thanksMessageForFront:'',

      scanButtonText:'Scan Me',
      typeRosterButtonText:'Roster',
      typeScanButtonText:'Scan Rec Cards',
      rosterCheckInButtonText:'Check In',
      loginButtonText:'Login',
      startOverButtonText:'OK',
      switchClubButtonText:'Switch Club',
      logoutButtonText:'Logout',
      cancelButtonText:'Cancel',

      scanPrompt:'Scan your Card',
      scanPromptDefault:'Scan your Card',

      /* scanPrompt:'Scan your Rec Card',
      scanPromptDefault:'Scan your Rec Card', */

      selectPrompt:'Select Check In Type',
      employeeCheckingInForPrompt:' checking members into ',
      checkedInMessage:' checked in to ',
      rosterPrompt:'Select Members',
      rosterPromptDefault:'Select Members for ',
      selectClubPrompt:'Select your club',
      selectClubPrompt_MemberDefault:'Select your club',
      selectClubPrompt_EmployeeDefault:'Select Club',
      passwordPrompt:'Enter your password',
      thanksMessage1:'Thanks for checking into',
      thanksMessage2:'for checking into',
      thanksDefaultPart1:'Thanks ',
      thanksDefaultPart2:' for checking in to ',
      rosterThanksMessage:'You checked in members',
      footerText:'powered by',

      monitorPrompt:'Are you monitoring the club today?',
      monitorButtonText:'I am a MONITOR today',
      attendeeButtonText:'I am a MEMBER today',
      lastError:{},

      timeSinceResult:0,
      myip:null,
      //lastImage:''

    }
    
  },
  components:{

  },
  methods:{
  
    buttonclass(club){
      if(club.isActive){return 'Button bold'}
      else{return 'ButtonInactive bold'}
    },
    rosterFiltered(){
        
            let temproster = this.roster;

            temproster = temproster.filter((item)=>{
                return (item.selected)
            })
            return temproster
            
            
       
    },
    getImageBasePath(){
      this.imageBasePath = window.VUE_CONFIG_API + 'personimage/'
            console.log("img path " + this.imageBasePath)
       // this.pleaseWait=true;
        /* HTTP.post('imagepath')
        .then(response=>{
            this.imageBasePath = response.data.StringResponse
            console.log("got imagepath " + this.imageBasePath)
            this.pleaseWait=false;
        })
        .catch(e=>{
            this.pleaseWait=false;
            return e

        }); */
    },
    getImage(imagePath){
     // imagePath=imagePath.replace('.jpg','')
    // if(this.lastImage==''){return ''}
    // return this.imageBasePath  + this.lastImage
     //this.lastImage=this.imageBasePath + imagePath
          //  return this.lastImage
            return this.imageBasePath + imagePath;
        //return require("../assets/" + imagePath)
    },
    logoPath(){
      return require("../assets/SCWEST LOGO.jpg")
    },
    footerLogoPath(){
      return require("../assets/MC_ID_Club.png")
    },
    setCurrentScreen(screenName){
      this.currentScreen=screenName;
    },
    isCurrentScreen(screenName){
      return this.currentScreen==screenName;
    },
    
    typeBadge(){
      this.showScanBadge()
    },
    typeRoster(){
      this.getRoster();
      this.rosterPrompt=this.rosterPromptDefault +  this.selectedClub.name
      this.setCurrentScreen('roster');
    },
    modeMonitor(){
       this.isEmployee=true;
      this.loggedInPerson=this.scannedPerson;
      this.isLoggedIn=true;
      this.monitorTitle=this.loggedInPerson.firstName + ' ' + this.loggedInPerson.lastName + this.employeeCheckingInForPrompt;
      this.selectClubPrompt=this.selectClubPrompt_EmployeeDefault;
      this.showSelectClub()
    },
    modeAttendee(){
     
      this.showSelectClub()
    },
    scanUserBadge(){
      this.thanksMessageForFront=''
      //this.lastImage=''
      //disallow empty scan
      if(this.badgeValue==null || this.badgeValue==''){
        return;
      }
      
      if(this.isEmployee==false){this.selectedClub.id=0}
      
      // initial scan

      let req = {
         lookupText:this.badgeValue,
         clubsOnly:true,
         club:this.selectedClub.id,
         ipAddress:this.myip
       }
       this.pleaseWait=true;
       HTTP.post('lookupbadge',req)
        .then(response=>{
            if(response.data.Person.isActive){
              console.log('scanning...' + this.badgeValue)
              this.scannedPerson = response.data.Person
              

              //only replace club list if we are not in employee/monitor mode
              if(this.isEmployee==false){
                this.clubs = response.data.Person.clubs
              }
              if(this.isEmployee){
                this.monitorScanResultMessage=response.data.inactiveMessage
              }else{
                this.messageOnScan=response.data.inactiveMessage
              }
              
              
              this.handleBadgeResult();
              
            }else{
              this.messageOnScan=response.data.inactiveMessage
              this.clearAndSetFocus()
            }
           // this.lastImage=this.badgeValue
            console.log('result')
              this.timeSinceResult=0
            this.pleaseWait=false;
        })
        .catch(e=>{
          this.lastError=e
            console.log(e)
            this.messageOnScan='Scan failed because of an API Error: ' + e
              this.clearAndSetFocus()
              this.pleaseWait=false;
        });
     

     },
    getIpAddress(){
      
      axios.get('https://api.ipify.org/?format=text')
      .then(response=>{
              
        this.myip=response.data
      })
        .catch(e=>{
          
            console.log(e)
            
        });
      //return response.data
    },

     handleBadgeResult(){
        if (this.isEmployee==false){
          this.checkForEmployee();
          
          
        }else{ //already in employee mode...straight to showing thanks
          this.checkIn(this.scannedPerson.id, this.selectedClub.id,this.selectedClub.name);
          
        }
     },
     checkForEmployee(){//figure out if the current scanned member is an employee
       if(this.scannedPerson.isEmployee){
         //find out what they want to do!
         this.setCurrentScreen("monitorOrAttendee")
          
         
       }else{ //regular member
         this.showSelectClub()
       }
     },
     
     loginEmployee(){
       this.isLoggedIn=true
       this.showSelectClub()
     },
     logoutEmployee(){
       this.isLoggedIn=false
       this.isEmployee=false
       this.startOver()
       
     },
     selectUserClub(clubid, clubName){
       this.selectedClub={id:clubid, name:clubName}
       if(this.isEmployee){
          this.monitorTitle=this.loggedInPerson.firstName + ' ' + this.loggedInPerson.lastName  + this.employeeCheckingInForPrompt + this.selectedClub.name
          this.setCurrentScreen('checkInType');
       }else{
         this.checkIn(this.scannedPerson.id, this.selectedClub.id,this.selectedClub.name);
         
       }
      
     },
     handleCheckInResult(response){
       
       if(this.isRosterCheckIn){
          this.thanksMessage1=this.rosterThanksMessage;
          this.setCurrentScreen('thanksRoster');
          this.isRosterCheckIn=false;
       }else if( this.isEmployee){
          if(response.Successful){
            this.scanPrompt=this.scannedPerson.firstName + ' ' + this.scannedPerson.lastName + this.checkedInMessage + this.selectedClub.name
          //  this.messageOnScan=response.message;
            this.clearAndSetFocus()
          }else{
            this.messageOnScan = response.message
            this.clearAndSetFocus()
          }   
       }else{
          if(response.Successful){
            this.messageOnScan = response.message
            this.thanksMessage1=this.thanksDefaultPart1 + this.scannedPerson.firstName + ' ' + this.scannedPerson.lastName;
            this.thanksMessageForFront = this.thanksDefaultPart1 + this.scannedPerson.firstName + ' ' + this.scannedPerson.lastName + ' ' + this.thanksMessage2 + ' ' + this.selectedClub.name;
            this.setCurrentScreen('scanBadge');
            this.clearAndSetFocus()
            //this.setCurrentScreen('thanks');
          }else{
            this.messageOnScan = response.message
            this.setCurrentScreen('scanBadge');
            this.clearAndSetFocus()
          }
         
       }
       
     },
     startOver(){
       this.showScanBadge()
       this.resetText()
       this.isRosterCheckIn=false;
     },
     
     showScanBadge(){
       this.setCurrentScreen('scanBadge');
       this.messageOnScan=''
    
        this.guestCount=0
       console.log("guests: " + this.guestCount)
       this.$nextTick(() => {
        this.$refs.badgeText.focus()
       })
     },
     clearAndSetFocus(){
       this.badgeValue=""
       
       this.guestCount=0
       console.log("guests: " + this.guestCount)
      this.$nextTick(() => {
        this.$refs.badgeText.focus()
       })
     },
     autoClear(){
       //if we are on main screen
      // console.log('clear' + this.timeSinceResult)
       if(this.currentScreen=='scanBadge'){
         if(this.timeSinceResult>=5){
           //this.clearAndSetFocus();
           this.messageOnScan='';
           this.thanksMessageForFront='';
           this.timeSinceResult=0
         }else{this.timeSinceResult=this.timeSinceResult+1}
         
       }
     },
     showSelectClub(){
       //this.getClubs();
        this.setCurrentScreen('selectClub');
        this.scanPrompt=this.scanPromptDefault;
     },
     resetText(){
       this.scanPrompt=this.scanPromptDefault;
       this.thanksMessage1= this.thanksDefaultPart1 + this.thanksDefaultPart2;
       this.selectClubPrompt=this.selectClubPrompt_MemberDefault;
       this.monitorTitle='';
     },

     
     getClubs(){
       let req = {
         memberID:"1"
       }
       this.pleaseWait=true;
       HTTP.post('clubs',req)
        .then(response=>{
            this.clubs = response.data.clubs
            this.pleaseWait=false;
        })
        .catch(e=>{
          this.pleaseWait=false;
            return e
        });
      },
      getRoster(){
        let req = {clubID:this.selectedClub.id}
        this.pleaseWait=true;
        HTTP.post('roster',req)
          .then(response=>{
              this.roster = response.data.PersonList
              this.pleaseWait=false;
          })
          .catch(e=>{
            this.pleaseWait=false;
              return e
          });
        
     },
     checkIn(personID, clubID,name){
         let req = {
           personID:personID, 
           clubID:clubID, 
           guestCount:this.guestCount,
           clubName:name,
           ipAddress:this.myip
              }
        HTTP.post('checkin',req)
          .then(response=>{
              
              this.handleCheckInResult(response.data);
          })
          .catch(e=>{
            console.log(e)
              return e
          });
      },
      checkInRoster(){
        this.isRosterCheckIn=true;
        var i;
        for(i=0;i<this.roster.length;i++){
            var person = this.roster[i]
            if(person.selected){
                this.checkIn(person.id, this.selectedClub.id, this.selectedClub.name)
            }
        }
      },
    

  },
  created(){
    const timer = setInterval(()=>{
          this.autoClear();
        },1000);
    
    this.$once("hook:beforeDestroy",()=>{
      clearInterval(timer);
    });
  },
  mounted(){
    this.getImageBasePath();
      this.showScanBadge()
      this.getIpAddress()
  },
  computed:{
      /* lastImagePath:function(){
        if(this.lastImage==''){return ''}
        return this.imageBasePath + this.lastImage
      }, */
    	showLogout:function(){return this.isLoggedIn;},
      showCancel:function(){return this.isEmployee==false && this.isCurrentScreen('selectClub');},
      showSwitchClub:function(){return this.isEmployee && (this.isCurrentScreen('scanBadge') || this.isCurrentScreen('roster') || this.isCurrentScreen('checkInType'));}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.wait{
    font-size:x-large;
    color:rgb(238,120,45);
    padding:20px;
}
.personPhoto{
    grid-area:photo;
    
}
.image{
    margin:5px;
    width:220px;
}

body{
  font-size:large;
  text-align: center;
  color:rgb(58, 54, 54);
}

/* header/footer */
header{
  grid-area:header;
}
footer{
  grid-area:footer;

  display:flex;
  flex-direction: column;
  justify-content: center;
  align-content:space-between;
}
.logo{
  margin:25px;
  height:115px;
  width:115px;
}
.footerText{
  font-size:small
}
.footerLogo{
 margin:0px 0px 15px 0px;
 height:45px;
}

/* main structure */
.outerDiv{
  height:90vh;
  display:grid;
  grid-template-columns:1fr 4fr 1fr;
  grid-template-rows:20px auto 80px 80px;
  grid-template-areas: 
    "header header header"
    "left center right"
    "button button button"
    "footer footer footer";
}
.currentScreenDiv{
  background-color: rgb(196, 218, 226);
  border-radius: 10px;
  padding:5px;
  grid-area:center;

  display:grid;
  grid-template-rows:auto;
  grid-template-columns:150px auto 150px;
}
/* .currentScreenDiv{
  background-color: rgb(196, 218, 226);
  border-radius: 10px;
  padding:20px;
  grid-area:center;

  display:flex;
  flex-direction: column;
  justify-content: center;
  align-content:space-between;
} */
.verticalFlex{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content:space-around;
  padding:20px;
}
.horizFlex{
  display:flex;
  flex-direction: row;
  margin:5px;
}
.leftFlex{
  display:flex;
  flex-direction: column;
  justify-content: left;
  margin:10px;
}

/* general */
.screenTitle{
  margin:10px;
}
.Button{
  background-color:yellow;
  color:black;
   padding:15px;
   border-radius:20px;
   border:none;
   font-size:xx-large;
   font-weight: bold;
   margin:10px 5px 10px 5px;
   min-width: 140px;
  
}
/* .Button{
  background-color:rgb(238,120,45);
  color:black;
   padding:15px;
   border-radius:20px;
   border:none;
   font-size:x-large;
   margin:10px 5px 10px 5px;
   min-width: 140px;
  
} */
.ButtonInactive{
  background-color:rgb(179, 173, 173);
  color:black;
   padding:15px;
   border-radius:20px;
   border:none;
   font-size:x-large;
   margin:10px 5px 10px 5px;
   min-width: 140px;
  
}
.linkButton{
  background-color: transparent;
  color: rgb(0,158,192);
  font-size:large;
  margin:20px;
  border:none;
}
.cancelbutton{
  background-color:rgb(0,158,192);
  color:white;
   padding:15px;
   border-radius:20px;
   border:none;
   font-size:large;
   margin:10px 5px 10px 5px;
   min-width: 120px;
}
/* scan */
.scanText{
  border-radius: 5px;
  margin:15px;
  font-size:inherit;
  border:none;
  width:150px;
}
.scanText:focus{
  outline-color:rgb(238,120,45);
}
.scanMessage{
  margin:10px;
  color:red;
  font-size:x-large;
}
.thankMessage{
  margin:10px;
  color:green;
  font-size:x-large;
}
/* link buttons */
.linkButtonArea{
  grid-area:button;
}

/* roster */
.rosterName{
  font-size:large;
  margin-left: 5px;
}
.scrollDivResults{
    height:300px;
    overflow-x:hidden;
    overflow-y:scroll;
}
.entrySelect{
  width:100px;
  font-size:large;
  border-radius:5px;
}
.bold{
  font-weight:bold;
}
</style>


// api
//         this.roster =[
//           {id:1, name:"Jake Jones",selected:false},
//           {id:2, name:"Fred Smith",selected:false},
//           {id:3, name:"Sally Jacobson",selected:false}
//         ]